import React from 'react'
import { withRouter } from 'react-router-dom'
import { withAuthentication } from '../Session'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import { AutoHeader } from '../Common'
import downloadForm from './config/download-form'

class DownloadCreatePage extends React.Component {
   render() {
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent form={downloadForm} {...this.props} />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(DownloadCreatePage)
